import { Link } from "react-router-dom";
import Button from "../Button/Button";
import Typography from "../Typography";

const PageNotFound = () => {
  return (
    <div className="page-not-found-container">
      <div className="text-center">
        <Typography variant="h1" className="page-not-found-404">
          404
        </Typography>
        <Typography variant="h2" className="page-not-found-title">
          Page Not Found
        </Typography>
        <Typography variant="text1" className="page-not-found-description">
          The page you are looking for does not exist or has been moved.
        </Typography>
        <Link to="/dashboard">
          <Button variant="primary" size="lg">
            Go to Dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
